<template>
    <div>
        <a-select v-model="currentEnv" style="width: 100px;margin-right:10px;" show-search @change="handleSelectChange">
            <a-select-option value="zl-life-logger-pro">
                正式环境
            </a-select-option>
            <a-select-option value="zl-life-logger">
                测试环境
            </a-select-option>
        </a-select>
    </div>
</template>

<script>

export default {
    model:{
        prop:'selectedWebEnv',
        event:'change'
    },
    props:{
        selectedWebEnv:String
    },
    data(){
        return {
            currentEnv:'',
            cacheKey: 'monitorweb_current_Envname_s'
        }
    },
    methods:{
        handleSelectChange(v){
            this.currentEnv = v;
            localStorage.setItem(this.cacheKey,v);
            this.$emit('change',v)
        },
        getCurrentEnv(defaultEnvName){
            let cachedEnv = localStorage.getItem(this.cacheKey);
            if(cachedEnv){
                return cachedEnv;
            }
            else{
                localStorage.setItem(this.cacheKey,defaultEnvName);
                return defaultEnvName;
            }
        }
    },
    mounted(){
        const {query} = this.$route;
        let default_env = ''
        if(query.qs){
            default_env = 'zl-life-logger-pro'
            this.currentEnv = default_env;
            this.$emit('change',this.currentEnv)
        }
        else{
            this.currentEnv = this.getCurrentEnv('zl-life-logger-pro');
            this.$emit('change',this.currentEnv)
        }
        
    },

    components:{

    }
};
</script>

<style lang="less" scoped>
</style>
